import React, { Component } from 'react'
import { Row, Col, Button, Spin, Table, Modal, Form, Input, Upload, Icon, Card, Select } from 'antd'
import utils from '../../utils'
import PlayerSelector from '../../components/PlayerSelector'
import { api, app, config } from '../../app'
import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils'

const FormItem = Form.Item
const TextArea = Input.TextArea
const Option = Select.Option

/**
 * 判断审核
 * @param audit
 * @returns {string}
 */
function checkAudit(audit) {
    switch (audit) {
        case '0':
            return '未审核'
        case '1':
            return '已通过'
        case '2':
            return '不通过'
    }
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload2(file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg, .gif】！', 'error')
        return Promise.reject(false)
    }

    return Promise.resolve(true)
}

class NRelease extends Component {
    constructor(props) {
        super(props)
        this.state = {
            send_visible: false,
            detailInfo: {},
            rights: app.getData('rights'),
            dataList: [],
            dataList2: [],
            gradeList: [],
            grade_loading: true,
            r_page: 1,
            r_total: 0,
        }
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 列表数据
     */
    dataSource = () => {
        this.setState({ data_loading: true }, async () => {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            let { flag, data, msg } = await app.post(api.PublishMessagetList, params)
            if (this._isMounted) {
                if (flag !== 1) {
                    app.alert(msg, 'error')
                    data = []
                }
                this.setState({ dataList: utils.addArrayKey(data), data_loading: false })
            }
        })
    }

    /**
     * 级别数据
     */
    dataGrade = async () => {
        await this.setState({ grade_loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.MessageGrade, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        await this.setState({ gradeList: utils.addArrayKey(data), grade_loading: false })
    }

    /**
     * 获取通知权限
     * @returns {Promise<void>}
     */
    getMessageAudit = async () => {
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.MessageAudit, params)
        if (flag === 1) {
            let rights = app.getData('rights'), nationwide_rights = data.nationwide_rights
            this.setData({ rights: nationwide_rights === 1 ? 1 : rights })
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 关闭详情弹框
     * @constructor
     */
    CloseDetailModal = () => {
        this.setState({ detail_visible: false })
    }

    /**
     * 打开详情弹框
     * @constructor
     */
    OpenDetailModal = (id) => {
        this.setState({ detail_visible: true, detail_loading: true }, async () => {
            const params = {
                id,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            let { flag, data, msg } = await app.post(api.PublishMessagetDetails, params)
            if (this._isMounted) {
                if (flag !== 1) {
                    app.alert(msg, 'error')
                }
                this.setState({ detail_loading: false, detailInfo: data })
            }
        })
    }

    componentDidMount() {
        this._isMounted = true
        this.dataSource()
        this.dataGrade()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 发布
     * @param e
     */
    handleSubmitSend = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                if (this.state.send_loading) return false
                const selector_value = this.pSelector.getValue()
                if (values.url && values.url.length > 0) {
                    values.url = values.url.map((url) => {
                        return (url.response.data || {}).url || ''
                    }).join(':::')
                } else {
                    values.url = ''
                }
                await this.setData({ send_loading: true })
                const param = Object.assign(selector_value, values)
                param.indexno = app.getData('indexno')
                param.account = app.getData('account')
                param.grade = values.grade
                param.content = values.content.toHTML()
                let { flag, msg } = await app.post(api.PublishMessage, param)
                if (flag === 1) {
                    app.alert('发布成功', 'success')
                    await this.setData({ send_loading: false, send_visible: false })
                    this.props.form.resetFields()
                    await this.dataSource()
                } else {
                    app.alert(msg, 'warn')
                    await this.setData({ send_loading: false })
                }
            }
        })
    }

    /**
     * 打开发布通知对话框
     * @param mall_id
     * @constructor
     */
    OpenSendModal = async () => {
        await this.getMessageAudit()
        this.setState({ send_visible: true })
    }

    /**
     * 关闭详情弹框
     */
    closeDetailModal = () => {
        this.setState({ detail_visible: false, data_loading: false, detailInfo: {} })
    }

    /**
     * 关闭发送通知对话框
     * @constructor
     */
    CloseSendModal = async () => {
        await this.setData({ send_visible: false })
        this.props.form.resetFields()
    }

    /**
     * 省份下拉框值变更
     */
    handleProvinceChange = (keys) => {
        if (keys.length > 0) {
            this.teamData(keys.join(','))
        }
    }

    /**
     * 查看阅读详情
     * @param id
     */
    handleOpenDetail = async (id) => {
        await this.setData({ detail_visible2: true, read_id: id })
        await this.handleReadData()
    }

    /**
     /**
     * 阅读数据
     * @param page
     * @returns {Promise<void>}
     */
    handleReadData = async (page = 1) => {
        await this.setData({ data_loading2: true, r_page: page })
        const params = {
            page,
            id: this.state.read_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.ReadCondition, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.r_page) {
            this.setData({ data_loading2: false, dataList2: utils.addArrayKey(data), r_total: parseInt(total || 0) })
        }
    }

    /**
     * 关闭阅读详情
     * @param id
     */
    handleCloseDetail = () => {
        this.setState({ detail_visible2: false, data_loading2: false, read_id: null, dataList2: [] })
    }

    onPlayerSelectorRef = (ref) => {
        this.pSelector = ref
    }

    /**
     * 编辑器图片上传
     * @param file
     * @returns {boolean}
     */
    editorUploadHandler = ({ file }) => {
        if (!file) {
            return false
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            console.log(this.props.form.getFieldValue('content'))
            this.props.form.setFieldsValue({
                content: ContentUtils.insertMedias(this.props.form.getFieldValue('content'), [{
                    type: 'IMAGE',
                    url: config.imgUrl + file.response.data.url
                }])
            })
        } else if (file.status === 'error') {
            app.alert('上传失败', 'error')
        }
    }

    render() {
        let columns = [
            {
                title: '已发布的通知',
                dataIndex: 'title',
                key: 'title',
                width: '50%'
            },
            {
                title: '发布人',
                dataIndex: 'vname',
                key: 'vname',
                width: '15%'
            },
            {
                title: '发布时间',
                dataIndex: 'cteate_time',
                key: 'cteate_time',
                width: '15%',
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'ckydqk',
                width: '20%',
                render: (text, record) => {
                    return (
                        <span>
                            <Button size="small" onClick={() => this.OpenDetailModal(record.id)}
                                style={{ marginRight: 10 }}>详情</Button>
                            <Button size="small" onClick={() => this.handleOpenDetail(record.id)}>查看阅读情况</Button>
                        </span>
                    )
                }
            },
        ],
            columns2 = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '18%'
                },
                {
                    title: '所属地区',
                    dataIndex: 'province',
                    key: 'province',
                    width: '18%'
                },
                {
                    title: '所属队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '28%'
                },
                {
                    title: '阅读时间',
                    dataIndex: 'read_time',
                    key: 'read_time',
                    width: '18%',
                },
                {
                    title: '阅读情况',
                    dataIndex: 'is_read',
                    key: 'is_read',
                    width: '18%',
                    render(text) {
                        return (<span>{text === '1' ? '已阅读' : '未阅读'}</span>)
                    }
                },
            ],
            {
                data_loading, data_loading2, dataList, dataList2, send_visible, send_loading,
                detail_visible, detail_loading, detailInfo, detail_visible2,
                gradeList, grade_loading, r_page, r_total
            } = this.state,
            { getFieldDecorator, getFieldValue } = this.props.form,
            grade = getFieldValue('grade'),
            formItemLayout = {
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 24 },
                },
            }
        const excludeControls = ['media', 'emoji', 'code'], extendControls = [
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/png,image/jpeg,image/gif"
                        showUploadList={false}
                        action={config.serverUrl + api.ImageUpload}
                        beforeUpload={beforeUpload2}
                        data={{
                            token: app.getData('token'),
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            upload_type: 'message'
                        }}
                        name="image"
                        onChange={(file) => this.editorUploadHandler(file)}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <button type="button" className="control-item button upload-button" data-title="插入图片">
                            <Icon type="picture" theme="filled" />
                        </button>
                    </Upload>
                )
            }
        ]
        return (
            <div className="n-page notice-release">
                <div className="page-title">发布通知</div>
                <div className="page-content">
                    <div className="sen-news"><Button onClick={() => this.OpenSendModal()}>发布新的通知</Button></div>
                    <Table columns={columns}
                        locale={app.tbLocale(data_loading)}
                        loading={data_loading}
                        dataSource={dataList}
                        scroll={{ y: 'calc(100% - 38px)' }}
                        pagination={false}
                        size="small"
                        className="notice-table"
                    />
                </div>
                <Modal
                    visible={send_visible}
                    // onOk={this.handleSubmitSend}
                    // onCancel={this.CloseSendModal}
                    okText="发布"
                    cancelText="取消"
                    footer={false}
                    title={<div style={{ textAlign: 'center' }}>发布通知</div>}
                    maskClosable={false}
                    confirmLoading={send_loading}
                    destroyOnClose={true}
                    keyboard={false}
                    width="100%"
                    style={{ top: 0, height: '100vh', minWidth: 1200 }}
                    bodyStyle={{ height: '100vh', overflow: 'auto' }}
                >
                    <Form layout="vertical">
                        <Row gutter={18}>
                            <Col span={12}>
                                <FormItem
                                    label="通知级别"
                                    colon={false}
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('grade', {
                                        rules: [
                                            { required: true, message: '请选择通知级别~' }
                                        ],
                                    })(
                                        <Select style={{ width: 200 }} placeholder="请选择通知级别"
                                            notFoundContent={grade_loading ? (<Spin size="small" />) : '无记录'}>
                                            {
                                                gradeList.map((g, i) => {
                                                    return (<Option key={i} value={g.grade_name}>{g.grade_name}</Option>)
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="标题"
                                    colon={false}
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('title', {
                                        rules: [
                                            { required: true, message: '请输入通知标题~' }
                                        ],
                                    })(
                                        <Input type="text" placeholder="请填写通知标题" />
                                    )}
                                </FormItem>
                                {
                                    grade ? (
                                        <PlayerSelector type="message" grade={grade} onRef={this.onPlayerSelectorRef} />) : null
                                }
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                    <Button onClick={this.CloseSendModal} style={{ marginRight: 8 }}>取消</Button>
                                    <Button onClick={this.handleSubmitSend} type='primary'>发布</Button>
                                </div>
                            </Col>
                            <Col span={12}>
                                <FormItem label="详细内容" {...formItemLayout}>
                                    {getFieldDecorator('content', {
                                        validateTrigger: 'onBlur',
                                        initialValue: BraftEditor.createEditorState(null),
                                        rules: [{
                                            required: true,
                                            validator: (_, value, callback) => {
                                                if (value.isEmpty()) {
                                                    callback('请填写通知内容')
                                                } else {
                                                    callback()
                                                }
                                            }
                                        }],
                                    })(
                                        <BraftEditor
                                            style={{ border: '1px solid #eee' }}
                                            excludeControls={excludeControls}
                                            extendControls={extendControls}
                                            stripPastedStyles={true}
                                            placeholder="请填写通知内容"
                                        />
                                    )}
                                </FormItem>
                                {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                    <Button onClick={this.CloseSendModal} style={{ marginRight: 8 }}>取消</Button>
                                    <Button onClick={this.handleSubmitSend} type='primary'>发布</Button>
                                </div> */}
                            </Col>
                        </Row>

                    </Form>
                </Modal>
                <Modal
                    visible={detail_visible2}
                    onCancel={this.handleCloseDetail}
                    footer={null}
                    title={<div style={{ textAlign: 'center' }}>查看阅读情况</div>}
                    destroyOnClose={true}
                    className="notice-release-detail-modal"
                    width={1000}
                    style={{ top: '10%' }}
                >
                    <Table columns={columns2}
                        locale={app.tbLocale(data_loading2)}
                        loading={data_loading2}
                        dataSource={dataList2}
                        size="small"
                        scroll={{ y: 400 }}
                        pagination={{
                            pageSize: 20,
                            current: r_page,
                            total: r_total,
                            onChange: this.handleReadData,
                            showTotal: (t) => `共${t}条`
                        }}
                    />
                </Modal>
                <Modal
                    visible={detail_visible}
                    onCancel={this.CloseDetailModal}
                    footer={null}
                    title={<div style={{ textAlign: 'center' }}>通知详情</div>}
                    width='80%'
                    maskClosable={false}
                    centered={true}
                    className="notice-release-detail"
                >
                    {
                        detail_loading ? <div style={{ textAlign: 'center' }}><Spin /></div> :
                            (
                                <div className="items">
                                    <Row className="item">
                                        <Col span={4}>标题：</Col>
                                        <Col span={20}>{detailInfo.title}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>通知级别：</Col>
                                        <Col span={20}>
                                            {detailInfo.object === '1' ? '全国' : (detailInfo.object === '2' ? '省级' : (detailInfo.object === '3' ? '市级' : '队伍'))}
                                        </Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>发布人：</Col>
                                        <Col span={20}>{detailInfo.vname}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>发布时间：</Col>
                                        <Col span={20}>{detailInfo.cteate_time}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>审核情况：</Col>
                                        {/*<Col>{detailInfo.title}</Col>*/}
                                        <Col span={20}>
                                            <Card bodyStyle={{ padding: 12 }} className="item-card"
                                                title="一级审核">
                                                {
                                                    detailInfo.one_indexno ?
                                                        (
                                                            <div>
                                                                <div>审核人：{detailInfo.one_indexno}</div>
                                                                <div>审核状态：{checkAudit(detailInfo.one_audit)}</div>
                                                                <div>审核时间：{detailInfo.one_time || '无'}</div>
                                                                {detailInfo.one_audit === '2' ?
                                                                    <div>不通过原因：{detailInfo.detail}</div> : null}
                                                            </div>
                                                        ) : '暂无审核'
                                                }
                                            </Card>
                                            {
                                                detailInfo.object === '1' ? [
                                                    (<Card key="1" bodyStyle={{ padding: 10 }} className="item-card"
                                                        title={'二级审核'}>
                                                        {
                                                            detailInfo.two_indexno ?
                                                                (
                                                                    <div>
                                                                        <div>审核人：{detailInfo.two_indexno}</div>
                                                                        <div>审核状态：{checkAudit(detailInfo.two_audit)}</div>
                                                                        <div>审核时间：{detailInfo.two_time || '无'}</div>
                                                                        {detailInfo.two_audit === '2' ?
                                                                            <div>不通过原因：{detailInfo.detail}</div> : null}
                                                                    </div>
                                                                ) : '暂无审核'
                                                        }
                                                    </Card>),
                                                    (<Card key="2" bodyStyle={{ padding: 10 }} className="item-card"
                                                        title={'三级审核'}>
                                                        {
                                                            detailInfo.three_indexno ?
                                                                (
                                                                    <div>
                                                                        <div>审核人：{detailInfo.three_indexno}</div>
                                                                        <div>审核状态：{checkAudit(detailInfo.three_audit)}</div>
                                                                        <div>审核时间：{detailInfo.three_time || '无'}</div>
                                                                        {detailInfo.three_audit === '2' ?
                                                                            <div>不通过原因：{detailInfo.detail}</div> : null}
                                                                    </div>
                                                                ) : '暂无审核'
                                                        }
                                                    </Card>)
                                                ]
                                                    : null
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>内容: </Col>
                                        <Col span={20}>
                                            <div className="braft-output-content"
                                                dangerouslySetInnerHTML={{ __html: detailInfo.content }} />
                                        </Col>
                                    </Row>
                                    {
                                        detailInfo.images && detailInfo.images.length ? (
                                            <Row className="item">
                                                <Col span={4}>图片：</Col>
                                                <Col span={20}>
                                                    {
                                                        detailInfo.images.map((img, index) => {
                                                            img = config.imgUrl + img
                                                            return (<a key={index} href={img} target="_blank"><img
                                                                className="d-img"
                                                                src={img} alt=""
                                                                key={index} /></a>)
                                                        })
                                                    }
                                                </Col>
                                            </Row>
                                        ) : null
                                    }
                                    <div className="item" style={{ textAlign: 'center' }}>
                                        <Button onClick={() => this.CloseDetailModal()}>关闭</Button>
                                    </div>
                                </div>
                            )
                    }
                </Modal>
            </div>
        )
    }
}

export default Form.create()(NRelease)



// WEBPACK FOOTER //
// ./src/routes/notice/NRelease.jsx